import {observer} from "mobx-react";
import {useState} from "react";
import {DialogStore, growlStore, slsWarehouseDetailStore, validationStore} from "../../../store";
import {ModalDialog, Page, PageContentTitle} from "../../ui";
import {SlsWarehouseForm} from "./SlsWarehouseForm";

const SlsWarehouseDetailPage = observer(function SlsWarehouseDetailPage() {
    const [cancelDialog] = useState(new DialogStore())
    const display = `${slsWarehouseDetailStore.name} (${slsWarehouseDetailStore.warehouseNumber})`

    return <Page
        breadcrumb={[
            {
                link: '/sls',
                label: 'Einlagerung'
            },
            {
                link: '/sls/warehouse',
                label: 'Lagerstandorte'
            },
            {
                link: `/sls/warehouse/create`,
                label: display
            }
        ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        slsWarehouseDetailStore.reset()
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${slsWarehouseDetailStore.creating ? 'is-loading' : ''}`,
                    disabled: !(slsWarehouseDetailStore.dirty && slsWarehouseDetailStore.valid),
                    action: async () => {
                        await slsWarehouseDetailStore.save()
                        slsWarehouseDetailStore.reset()
                        growlStore.add({
                            message: 'Der Lagerstandort wurde erfolgreich gespeichert',
                            autoclose: true,
                            closable: true
                        })
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: slsWarehouseDetailStore.creating || !slsWarehouseDetailStore.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <SlsWarehouseForm
            value={{
                name: slsWarehouseDetailStore.name || '',
                warehouseNumber: slsWarehouseDetailStore.warehouseNumber || '',
                addresses: slsWarehouseDetailStore.addresses,
            }}
            validationFor={(k: string) => validationStore.getFor(k)}
            disabled={slsWarehouseDetailStore.creating}
            help={{
                name: validationStore.getFor('name'),
                warehouseNumber: validationStore.getFor('warehouseNumber')
            }}
            onChange={v => {
                slsWarehouseDetailStore.name = v.name || undefined
                slsWarehouseDetailStore.warehouseNumber = v.warehouseNumber || undefined
                slsWarehouseDetailStore.addresses = v.addresses
            }}
            onDelete={(position) => slsWarehouseDetailStore.deleteAddress(position)}
            validate={async () => slsWarehouseDetailStore.validate()}
            addAddress={async (v) => {
                slsWarehouseDetailStore.addresses = v
                await slsWarehouseDetailStore.validate()
            }}
        />
    </Page>
})

export {
    SlsWarehouseDetailPage
}
